/**
 * @desc 修改
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationPlanUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationPlan/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
